import React from 'react';
import PropTypes from 'prop-types';
import { Line } from 'react-chartjs-2';
import RefreshIndicator from 'material-ui/RefreshIndicator';
import styles from 'pages/Dashboard/styles';
import dateUtils from 'helpers/dateUtils';
import utils from 'helpers/utils';
import translate from 'components/hoc/translate';
import { isIntervalByHour, useGraphConfig } from 'helpers/graph';

const otherGraphOptions = {
    yAxes: [
        {
            ticks: {
                beginAtZero: true,
                precision: 0,
            },
        },
    ],
};

const ProductOccupancyGraph = (props) => {
    const {
        datasets,
        interval,
        loading,
        rawData,
        title,
        translate,
    } = props;

    const tooltipItemLabelCallback = function (tooltipItem) {
        return `${ translate(`resources.products.occupancy.graph.label.${ datasets[tooltipItem.datasetIndex].key }`) } ${ Number(tooltipItem.yLabel) }`;
    };

    const options = useGraphConfig(tooltipItemLabelCallback, otherGraphOptions);

    const labels = utils.map(rawData, (data) => {
        if (isIntervalByHour(interval)) {
            return `${ dateUtils.formatDateFromString(data.label) } ${ dateUtils.formatTimeFromString(data.label) }`;
        }

        return data.label;
    });

    return (
        <div>
            { loading &&
                <RefreshIndicator size={ 40 } top={ 30 } left={ 0 } status={ 'loading' } style={ { marginLeft: '50%' } } />
            }

            <div>
                <div style={ styles.card.title }>{ title }</div>

                <div style={ { width: '96%', height: '400px', margin: '0 auto' } }>
                    <Line
                        data={ {
                            labels: labels,
                            datasets: datasets,
                        } }
                        options={ options }
                    />
                </div>
            </div>
        </div>
    );
};

ProductOccupancyGraph.propTypes = {
    datasets: PropTypes.arrayOf(PropTypes.object).isRequired,
    interval: PropTypes.string,
    loading: PropTypes.bool,
    rawData: PropTypes.arrayOf(PropTypes.object).isRequired,
    title: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
};

export default translate(ProductOccupancyGraph);


// WEBPACK FOOTER //
// ./src/pages/products/productOccupancy/graph/ProductOccupancyGraph.js